import 'dayjs/locale/sr'
import { Dayjs } from 'dayjs'

const sr = {
  calendar: {
    sameDay: '[danas u] LT',
    nextDay: '[sutra u] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[u] [nedelju] [u] LT')
        case 3:
          return now.format('[u] [sredu] [u] LT')
        case 6:
          return now.format('[u] [subotu] [u] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[u] dddd [u] LT')
      }
    },
    lastDay: '[juče u] LT',
    lastWeek: function (now: Dayjs) {
      var lastWeekDays = [
        '[prošle] [nedelje] [u] LT',
        '[prošlog] [ponedeljka] [u] LT',
        '[prošlog] [utorka] [u] LT',
        '[prošle] [srede] [u] LT',
        '[prošlog] [četvrtka] [u] LT',
        '[prošlog] [petka] [u] LT',
        '[prošle] [subote] [u] LT'
      ]
      return now.format(lastWeekDays[now.day()])
    },
    sameElse: 'L'
  }
}

export default sr
